import React from 'react'
// @ts-ignore
import { MapMarker, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MetadataIconsContainer from './MetadataIconsContainer'

type MapMarkerIconProps = {
  message: string
  tooltip: string
}

const MapMarkerIcon = ({ message, tooltip }: MapMarkerIconProps) => {
  const theme = useDisplayTheme() as Theme
  const color = sys[theme].text.placeholder

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={message}>
          <MapMarker color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default MapMarkerIcon
